'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateFDIQuotes = exports.generateQuotes = exports.quoted = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
var quoted = exports.quoted = function quoted(data) {
  return data.quoted;
};
var generateQuotes = exports.generateQuotes = function generateQuotes(data) {
  return {
    quotes: data.quoteCollection,
    quoteRef: data.logId || data.quoteRef
  };
};
var generateFDIQuotes = exports.generateFDIQuotes = function generateFDIQuotes(data) {
  return {
    fdiQuotes: Object.entries(data).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return Object.assign({}, value, {
        milage: key
      });
    }),
    fdiQuoteRef: data.quoteRef
  };
};
var initialState = {
  fetching: false,
  fetchingFDI: false,
  requestError: false,
  quoteError: false,
  fdiQuoteError: false,
  quoteRef: '',
  fdiQuoteRef: '',
  dlAttribution: '',
  params: {
    abiCode: '',
    age: '',
    postcode: '',
    regNo: '',
    value: '',
    type: '',
    coverStartDate: ''
  },
  quotes: [],
  fdiQuotes: [],
  policy: {}
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.FULL_QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetching: true,
          requestError: false,
          quoteError: false,
          quotes: []
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          fetching: false,
          requestError: true
        });
      }
    case _constants.actionTypes.FULL_QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        if (action.payload.response.data.error.code === 1000) {
          return Object.assign({}, state, {
            fetching: false,
            requestError: false,
            quoteError: true
          });
        }
        return Object.assign({}, initialState, {
          fetching: false,
          requestError: true
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.status === 'SUCCESS' && quoted(action.payload.data.data)) {
          var data = action.payload.data.data;
          return Object.assign({}, state, {
            dlAttribution: state.dlAttribution,
            fetching: false,
            requestError: false,
            quoteError: false,
            params: action.meta.params
          }, generateQuotes(data));
        }
        return Object.assign({}, state, {
          fetching: false,
          requestError: false,
          quoteError: true
        });
      }
    case _constants.actionTypes.FULL_QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.status === 'SUCCESS') {
          var _data = action.payload.data.data;
          return Object.assign({}, state, {
            dlAttribution: state.dlAttribution,
            fetching: false,
            requestError: false,
            quoteError: false,
            params: action.meta.params,
            quotes: _data.quote.quoteCollection,
            quoteRef: _data.quote.quoteRef,
            policy: _data.policy
          });
        }
        return Object.assign({}, state, {
          fetching: false,
          requestError: false,
          quoteError: true
        });
      }
    case _constants.actionTypes.FDI_QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetchingFDI: true,
          requestError: false,
          fdiQuoteError: false,
          fdiQuotes: []
        });
      }
    case _constants.actionTypes.FDI_QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          fetchingFDI: false,
          requestError: true
        });
      }
    case _constants.actionTypes.FDI_QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.status === 'SUCCESS') {
          var _data2 = action.payload.data.data;
          return Object.assign({}, state, {
            fetchingFDI: false,
            requestError: false,
            fdiQuoteError: false,
            params: action.meta.params
          }, generateFDIQuotes(_data2));
        }
        return Object.assign({}, state, {
          fetchingFDI: false,
          requestError: false,
          fdiQuoteError: true
        });
      }
    case _constants.actionTypes.SET_DL_ATTRIBUTION:
      return Object.assign({}, state);
    case _constants.actionTypes.CLEAR_QUOTES:
      {
        return initialState;
      }
    default:
      return state;
  }
};